import {Branding} from "@irati/types"
import Observable from "zen-observable"
import defaultBranding from "@irati/brand/helpers/fallBackBranding"
import AuthStorage from "../auth/storage"
import AuthServiceAbstract from "../auth/base"

interface Global {
  branding: Branding
}

class GlobalStream extends AuthServiceAbstract<Global> {
  isValid(auth: Global) {
    return !!auth.branding
  }

  async init() {
    return this.storage.get().then((data) => {
      this.start(data)
    })
  }

  protected query() {
    return async () =>
      new Observable<{data: Global}>((observer) => {
        observer.next({data: {branding: defaultBranding}})
      })
  }
}

export default new GlobalStream({storage: new AuthStorage("global")})
